import { Container, Grid, Typography, useMediaQuery } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import ReportsComponent from '../../components/Reports/ReportsComponent';
import React, { useEffect } from 'react';
import UserRole from '../../../shared/AuthRoles';

export default function ReportsPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const loggedInUser = UserRole();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Grid
                sx={{
                    width: '100%',
                    height: isMobile || isIpad ? '2%' : '5%',
                    justifyContent: 'left',
                    display: 'flex',
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    Reports
                </Typography>
            </Grid>

            <Grid
                sx={{
                    width: '100%',
                    // minHeight: isMobile || isIpad ? '65%' : '95%',
                    // justifyContent: 'flex-start',
                    // paddingBottom: isMobile || isIpad ? '40px' : '0px',
                }}
            >
                <ReportsComponent />
            </Grid>
        </Grid>
    );
}
